import { Injectable } from '@angular/core';
import { TranslateService } from '@jht/brand-translate';
import { KeyifyPipe } from '@jht/brand-translate';
import { GenerateKeyPipe } from '../shared/generate-key.pipe';

@Injectable({
    providedIn: 'root',
})
export class PartialsHelpersService {
    private generateKeyPipe = new GenerateKeyPipe();

    constructor(
        private keyify: KeyifyPipe,
        private translate: TranslateService,
    ) {}

    translateContentGroup(
        productData: any,
        keySlug: string,
        suffixes: string[],
        range?: number[],
    ): any[] {
        const baseName = this.keyify.transform(productData['product-name']);
        const consoleName = this.keyify.transform(
            productData?.activeConsole?.['console-name'],
        );

        const generateKeys = (
            keySlug: string,
            suffixes: string[],
            index?: number,
        ) => {
            return suffixes.reduce((group, suffix) => {
                const suffixKey = this.normalizeSuffix(suffix);
                const blockSuffix =
                    index !== undefined
                        ? `${keySlug}-${index}_${suffixKey}`
                        : `${keySlug}_${suffixKey}`;
                const key = `PRODUCT-PAGE_${this.generateKeyPipe.transform(
                    baseName,
                    consoleName,
                    blockSuffix,
                )}`;
                const translatedKey = this.translate.instant(key);
                group[suffix] = translatedKey !== key ? translatedKey : false;
                return group;
            }, {} as Record<string, string | false>);
        };

        if (range.length === 0) {
            const allKeys = generateKeys(keySlug, suffixes);
            const hasValidKeys = Object.values(allKeys).some(
                (value) => value !== false,
            );
            return hasValidKeys ? [allKeys] : [];
        }

        const allKeys = (range || []).map((i) =>
            generateKeys(keySlug, suffixes, i),
        );

        const hasValidContent = allKeys.some((group) =>
            Object.values(group).some((value) => value !== false),
        );
        return hasValidContent ? allKeys : [];
    }

    hasValidTranslation(groupedContent: Record<string, any[]>): boolean {
        return Object.values(groupedContent).some((arr) =>
            arr.some((obj) =>
                Object.values(obj).some((val) =>
                    !!val && typeof val === 'string'
                        ? val.trim() !== ''
                        : !!val,
                ),
            ),
        );
    }

    private normalizeSuffix(suffix: string): string {
        return String(suffix)
            .replace(/[A-Z]/g, (match) => '_' + match)
            .toUpperCase()
            .replace(/(DESKTOP|TABLET|MOBILE)_/g, '$1-');
    }
}
